import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../../Config/swal.css";
// import { Select } from "antd";
import { Input, Select } from "antd";
import { Footer } from "../footer/footer";


export default function AddExpense() {

    const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [userDetails, SetUserDetails] = useState([]);
  const userId = userDetails?.userId || userDetails?.staffid;
  const [customersData, setCustomersData] = useState([]);
  const [selectedCustomerid, setSelectedCustomerid] = useState("");

  const [categoriesData, setCategoriesData] = useState([]);
  const [selectedCategoryid, setSelectedCategoryid] = useState("");

  const [paymentModeData, setPaymentModeData] = useState([]);
  const [selectedPaymentid, setSelectedPaymentid] = useState("");

  const [taxesData, setTaxesData] = useState([]);
  const [selectedTaxid, setSelectedTaxid] = useState("");

  const [projectOptions, setProjectOptions] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const [currencyData, setCurrencyData] = useState([]);
  const [selectedCurrencyId, setSelectedCurrencyId] = useState("");

  const [selectedDate, setSelectedDate] = useState("");

  const [formData, setFormData] = useState({
    category: "",
    currency: "",
    amount: "",
    tax: "",
    note: "",
    expense_name: "",
    clientid: "",
    paymentmode: "",
    date: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);

  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          customersResponse,
          categoriesResponse,
          paymentModesResponse,
          taxesResponse,
          currencyResponse,
        ] = await Promise.all([
          fetch(`${API_BASE_CRM_URL}customers/GetCustomers`),
          fetch(`${API_BASE_CRM_URL}expenses/GetExpenseCategories`),
          fetch(`${API_BASE_CRM_URL}expenses/GetPaymentModes`),
          fetch(`${API_BASE_CRM_URL}GetTaxes`),
          fetch(`${API_BASE_CRM_URL}GetCurrencies`),
        ]);

        if (
          !customersResponse.ok ||
          !categoriesResponse.ok ||
          !paymentModesResponse.ok ||
          !taxesResponse.ok ||
          !currencyResponse.ok
        ) {
          throw new Error("Failed to fetch data");
        }

        const customersData = await customersResponse.json();
        const categoriesData = await categoriesResponse.json();
        const paymentModesData = await paymentModesResponse.json();
        const taxesData = await taxesResponse.json();
        const currencyData = await currencyResponse.json();

        if (customersData.Status) setCustomersData(customersData.ResultData);
        if (categoriesData.Status) setCategoriesData(categoriesData.ResultData);
        if (paymentModesData.Status)
          setPaymentModeData(paymentModesData.ResultData);
        if (taxesData.Status) setTaxesData(taxesData.ResultData);
        if (currencyData.Status) setCurrencyData(currencyData.Data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);

  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const customerOptions =
    customersData &&
    customersData.map((item) => ({
      value: item.customerId,
      label: item.company,
    }));

  const categoryOptions =
    categoriesData &&
    categoriesData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const taxOptions = taxesData.map((item) => ({
    value: item.Id,
    label: item.Name,
  }));

  const paymentModeOptions =
    paymentModeData &&
    paymentModeData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  // const projectOptions = proejctsData && proejctsData.map((item) => ({
  //     value: item.id,
  //     label: item.name,
  // }));

  const currencyOptions =
    currencyData &&
    currencyData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const handleCategoryChange = (value) => {
    setSelectedCategoryid(value);

    setFormData((prev) => ({
      ...prev,
      category: value,
    }));
  };

  const handleCustomerChange = (value) => {
    setSelectedCustomerid(value);

    setFormData((prev) => ({
      ...prev,
      clientid: value,
    }));
  };

  const handleTaxChange = (value) => {
    setSelectedTaxid(value);

    setFormData((prev) => ({
      ...prev,
      tax: value,
    }));
  };

  const handleCurrencyChange = (value) => {
    setSelectedCurrencyId(value);

    setFormData((prev) => ({
      ...prev,
      currency: value,
    }));
  };

  const handlePaymentChange = (value) => {
    setSelectedPaymentid(value);

    setFormData((prev) => ({
      ...prev,
      paymentmode: value,
    }));
  };

  // const handleProjectChange = (selectedone) => {
  //   setSelectedProjectid(selectedone);
  // };
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    // 2 MB limit
    const maxSize = 2 * 1024 * 1024;

    if (file.size > maxSize) {
      Swal.fire({
        title: "File Too Large",
        text: "Maximum file size allowed is 2 MB.",
        icon: "warning",
        confirmButtonText: "OK",
      });

      e.target.value = "";
      return;
    }

    setSelectedFile(file);

    if (file.type.startsWith("image/")) {
      setFilePreview(URL.createObjectURL(file));
    } else {
      setFilePreview(null);
    }
  };

  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
        },
        audio: false,
      });

      setCameraStream(stream);
      setCameraOpen(true);
    } catch (error) {
      console.error("Camera error:", error);

      Swal.fire({
        title: "Camera Access Required",
        text: "Please allow camera permission to take a photo.",
        icon: "warning",
      });
    }
  };

  const removeSelectedFile = () => {
    setSelectedFile(null);
    setFilePreview(null);
  };

  const handleSelectDate = (e) => {
    setSelectedDate(e.target.value);

    setFormData((prev) => ({
      ...prev,
      date: e.target.value,
    }));
  };



  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("category", Number(formData.category));
      formDataToSend.append("currency", 5);
      formDataToSend.append("amount", Number(formData.amount));
      formDataToSend.append("tax", Number(formData.tax));
      formDataToSend.append("tax2", 0);
      formDataToSend.append("note", formData.note);
      formDataToSend.append("expense_name", formData.expense_name);
      formDataToSend.append("clientid", Number(formData.clientid));
      formDataToSend.append("paymentmode", Number(formData.paymentmode));
      formDataToSend.append("date", formData.date);
      formDataToSend.append("send_invoice_to_customer", 0);
      formDataToSend.append("addedfrom", userId || "");
      formDataToSend.append("project_id", selectedProject || "");

      formDataToSend.append("reference", "");

      // File
      if (selectedFile) {
        formDataToSend.append("file", selectedFile);
      }

      for (const [key, value] of formDataToSend.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_CRM_URL}expenses/AddExpense`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      if (result.Status) {
        setLoading(false);

        Swal.fire({
          title: "Expense Added Successfully.",
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            navigate("/expenses");
          }
        });
      } else {
        setLoading(false);

        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);

      setLoading(false);

      Swal.fire({
        title: "Error",
        text: "An error occurred while submitting the request.",
        icon: "error",
      });
    }
  };

  return (
    <Base>
      <div className="page-heade mb-3">
        {/* <div className="container"> */}
        <div className="row align-items-center">
          <div className="col-8">
            <div className="page-title">
              <h4>Add Expense</h4>
              <p className="fw-semibold">
                Fill out the form to add a new expense
              </p>
            </div>
          </div>
          <div className="col-4 d-flex justify-content-end">
            <Link to="/expenses">
              <button className="btn btn-sm btn-secondary">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
          {/* </div> */}
        </div>
      </div>

      <div className="col-xxl-12 col-xl-12">
        <div className="card">
          <div
            className="card-body"
            style={{ maxHeight: "100vh", overflowY: "auto" }}
          >
            <form onSubmit={handleSubmit}>
              <div className="row  g-3">
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Attachment (Max:2MB)
                  </label>

                  <div className="d-flex gap-2 flex-wrap">
                    {/* Upload File */}
                    <label
                      htmlFor="expense-file"
                      className="btn btn-outline-primary"
                      style={{
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa-solid fa-paperclip me-2"></i>
                      Upload File
                    </label>

                    <input
                      id="expense-file"
                      type="file"
                      accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />

                    {/* Camera */}
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={openCamera}
                      style={{
                        borderRadius: "8px",
                      }}
                    >
                      <i className="fa-solid fa-camera me-2"></i>
                      Take Photo
                    </button>

                    <input
                      id="expense-camera"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </div>

                  {cameraOpen && (
                    <div className="mt-3 border rounded p-3">
                      <video
                        id="expense-camera-video"
                        autoPlay
                        playsInline
                        muted
                        style={{
                          width: "100%",
                          maxHeight: "400px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                        ref={(video) => {
                          if (video && cameraStream) {
                            video.srcObject = cameraStream;
                          }
                        }}
                      />

                      <div className="d-flex justify-content-center gap-2 mt-3">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            const video = document.querySelector(
                              "#expense-camera-video",
                            );

                            if (!video) return;

                            const canvas = document.createElement("canvas");

                            canvas.width = video.videoWidth;
                            canvas.height = video.videoHeight;

                            const context = canvas.getContext("2d");

                            context.drawImage(
                              video,
                              0,
                              0,
                              canvas.width,
                              canvas.height,
                            );

                            canvas.toBlob(
                              (blob) => {
                                if (!blob) return;

                                const file = new File(
                                  [blob],
                                  `expense-${Date.now()}.jpg`,
                                  {
                                    type: "image/jpeg",
                                  },
                                );

                                setSelectedFile(file);
                                setFilePreview(URL.createObjectURL(file));

                                cameraStream?.getTracks().forEach((track) => {
                                  track.stop();
                                });

                                setCameraStream(null);
                                setCameraOpen(false);
                              },
                              "image/jpeg",
                              0.9,
                            );
                          }}
                        >
                          <i className="fa-solid fa-camera me-2"></i>
                          Capture
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => {
                            cameraStream?.getTracks().forEach((track) => {
                              track.stop();
                            });

                            setCameraStream(null);
                            setCameraOpen(false);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Selected File */}
                  {selectedFile && (
                    <div className="mt-3 p-2 border rounded">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          {filePreview ? (
                            <img
                              src={filePreview}
                              alt="Preview"
                              style={{
                                width: "55px",
                                height: "55px",
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            <i className="fa-solid fa-file fa-2x text-muted"></i>
                          )}

                          <div>
                            <div className="fw-semibold">
                              {selectedFile.name}
                            </div>

                            <small className="text-muted">
                              {(selectedFile.size / 1024).toFixed(2)} KB
                            </small>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={removeSelectedFile}
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-12">
                  <Input
                    placeholder="Expense Name *"
                    name="expense_name"
                    size="large"
                    value={formData.expense_name}
                    onChange={handleChange}
                    required
                    prefix={
                      <i className="fa-solid fa-file-invoice-dollar text-muted" />
                    }
                  />
                </div>

                <div className="col-12">
                  <Input
                    type="date"
                    size="large"
                    onChange={handleSelectDate}
                    required
                    prefix={
                      <i className="fa-solid fa-calendar-days text-muted" />
                    }
                  />
                </div>

                <div className="col-12">
                  <Input
                    type="number"
                    name="amount"
                    size="large"
                    value={formData.amount}
                    placeholder="Amount *"
                    onChange={handleChange}
                    required
                    prefix={
                      <i className="fa-solid fa-indian-rupee-sign text-muted" />
                    }
                  />
                </div>

                <div className="col-6">
                  <Select
                    showSearch
                    placeholder="Category *"
                    size="large"
                    value={selectedCategoryid || null}
                    onChange={handleCategoryChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={categoryOptions}
                    style={{ width: "100%" }}
                    suffixIcon={<i className="fa-solid fa-layer-group" />}
                  />
                </div>

                <div className="col-6">
                  <Select
                    showSearch
                    placeholder="Customer"
                    size="large"
                    value={selectedCustomerid || null}
                    onChange={(value) => {
                      setSelectedCustomerid(value);
                      setFormData((prev) => ({
                        ...prev,
                        clientid: value,
                      }));

                      handleCustomerChange(value);
                      getProjects(value);

                      // Clear previous project when customer changes
                      setSelectedProject(null);
                      setFormData((prev) => ({
                        ...prev,
                        project_id: "",
                      }));
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={customerOptions}
                    style={{ width: "100%" }}
                    suffixIcon={<i className="fa-solid fa-building-user" />}
                  />
                </div>

                {selectedCustomerid && (
                  <div className="col-6">
                    <Select
                      placeholder="Select Project"
                      style={{ width: "100%", height: 38 }}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      loading={projectLoading}
                      options={projectOptions}
                      value={selectedProject || null}
                      onChange={(value) => {
                        setSelectedProject(value);

                        setFormData((prev) => ({
                          ...prev,
                          project_id: value || "",
                        }));
                      }}
                    />
                  </div>
                )}
                <div className="col-6 d-none">
                  <Select
                    showSearch
                    placeholder="Currency"
                    size="large"
                    value={selectedCurrencyId || null}
                    onChange={handleCurrencyChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={currencyOptions}
                    style={{ width: "100%" }}
                    suffixIcon={<i className="fa-solid fa-money-bill-wave" />}
                  />
                </div>

                <div className="col-6">
                  <Select
                    showSearch
                    placeholder="Tax"
                    size="large"
                    value={selectedTaxid || null}
                    onChange={handleTaxChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={taxOptions.map((option) => ({
                      ...option,
                      key: option.key,
                    }))}
                    style={{ width: "100%" }}
                    suffixIcon={<i className="fa-solid fa-percent" />}
                  />
                </div>

                <div className="col-6">
                  <Select
                    showSearch
                    placeholder="Payment Mode"
                    size="large"
                    value={selectedPaymentid || null}
                    onChange={handlePaymentChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={paymentModeOptions}
                    style={{ width: "100%" }}
                    suffixIcon={<i className="fa-solid fa-credit-card" />}
                  />
                </div>

                <div className="col-12">
                  <Input.TextArea
                    rows={4}
                    name="note"
                    size="large"
                    value={formData.note}
                    placeholder="Description"
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="btn"
                  style={{
                    backgroundColor: "#0A1F3E",
                    borderColor: "#0A1F3E",
                    borderRadius: "10px",
                    minWidth: "150px",
                    color: "#ffff",
                  }}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </Base>
  );
}
